import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { handlePaginatedParameters } from "../_helpers/handle-parameters";
import { optionsWithDefaultsPaginated } from "../_helpers/options-with-defaults";
import { PaginatedOptions, UseQueryOptionsNoKeyAndFn } from "../_types";
import {
  VEHICLE_VALUATION_COST_ADDITION_RESOURCE,
  VEHICLE_VALUATION_COST_ADDITION_SEARCH_API_PATH,
  VEHICLE_VALUATION_COST_ADDITION_SEARCH_OPERATION,
  type VehicleValuationCostAdditionSearchBody,
  type VehicleValuationCostAdditionSearchParameters,
  type VehicleValuationCostAdditionSearchResponse,
} from "./vehicle-valuation-cost-addition.types";

export function useVehicleValuationCostAdditionSearchQuery({
  options,
  enabled,
  queryOptions,
}: {
  options?: PaginatedOptions<VehicleValuationCostAdditionSearchParameters, VehicleValuationCostAdditionSearchBody>;
  enabled?: boolean;
  queryOptions?: UseQueryOptionsNoKeyAndFn<
    VehicleValuationCostAdditionSearchResponse,
    Error,
    VehicleValuationCostAdditionSearchResponse,
    readonly unknown[]
  >;
} = {}) {
  const optionsWithDefaults =
    optionsWithDefaultsPaginated<
      PaginatedOptions<VehicleValuationCostAdditionSearchParameters, VehicleValuationCostAdditionSearchBody>
    >(options);
  const params = handlePaginatedParameters(optionsWithDefaults.parameters);
  const body = optionsWithDefaults.body;

  return useQuery({
    queryKey: [
      VEHICLE_VALUATION_COST_ADDITION_RESOURCE,
      VEHICLE_VALUATION_COST_ADDITION_SEARCH_OPERATION,
      { params, body },
    ],
    queryFn: async () => {
      const response = await alphartisApiAxios.post<VehicleValuationCostAdditionSearchResponse>(
        VEHICLE_VALUATION_COST_ADDITION_SEARCH_API_PATH,
        body,
        {
          params,
        },
      );

      return response.data;
    },
    ...queryOptions,
    enabled,
  });
}
